
export default {
  name: 'header-titulo',
  props: {
    proposta: {
      type: Object
    },
    exibeMensagem: {
      type: Boolean
    },
  }
}
